import { SVGProps, Ref, forwardRef } from 'react';

export const PhoneWaveFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m5.67 0 3.91 5.62-1.3 3.045c-.217.506-.221 1.078.063 1.55.404.673 1.157 1.747 2.438 3.028 1.275 1.275 2.346 2.026 3.02 2.432.477.287 1.056.28 1.567.057l3.01-1.318L24 18.324c-2.605 9.193-11.002 5.93-17.618-.684C-.235 11.027-3.534 2.598 5.67 0M14.9.353a12.02 12.02 0 0 1 8.746 8.746l-1.777.317a10.22 10.22 0 0 0-7.286-7.286zm4.902 9.432a7.51 7.51 0 0 0-5.588-5.588l-.317 1.776a5.71 5.71 0 0 1 4.13 4.13z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
PhoneWaveFilledSize24Glyph.displayName = 'PhoneWaveFilledSize24Glyph';
